import React, { useState } from "react";
import Field from "../shared/Field";
import { inputStyle } from "../shared/inputStyle";

export default function ModifiersFields({
  education,
  setEducation,
  experience,
  setExperience,
  cityTier,
  setCityTier,
}) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border border-[#f0801733] rounded-lg overflow-hidden mt-8">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center py-2 px-4 bg-white hover:bg-gray-100 transition-colors"
      >
        <span className="text-[15px] text-gray-700">تنظیمات پیشرفته</span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="p-4 bg-white border-t border-gray-200">
          <div className="grid sm:grid-cols-3 gap-4">
            <Field label="مدرک تحصیلی وکیل">
              <select
                value={education}
                onChange={(e) => setEducation(e.target.value)}
                className="input"
                style={inputStyle}
              >
                <option value="none">کارشناسی / بدون افزایش</option>
                <option value="masters">کارشناسی ارشد (تا ۵٪)</option>
                <option value="phd">دکترا (تا ۱۰٪)</option>
              </select>
            </Field>

            <Field label="سنوات خدمت (سال)">
              <input
                type="number"
                min={0}
                max={30}
                value={experience}
                onChange={(e) => setExperience(e.target.value)}
                className="input"
                style={inputStyle}
              />
            </Field>

            <Field label="محل اشتغال وکیل">
              <select
                value={cityTier}
                onChange={(e) => setCityTier(e.target.value)}
                className="input"
                style={inputStyle}
              >
                <option value="none">سایر مناطق</option>
                <option value="tehran">تهران / مراکز استان (تا ۱۰٪)</option>
                <option value="other">سایر شهرهای بزرگ (تا ۵٪)</option>
              </select>
            </Field>
          </div>
        </div>
      )}
    </div>
  );
}
